import React from 'react';
import {Link,withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import {Dropdown, DropdownMenu, DropdownToggle} from 'reactstrap';
import {
    BELOW_THE_HEADER,
    COLLAPSED_DRAWER,
    FIXED_DRAWER,
    HORIZONTAL_NAVIGATION,
    INSIDE_THE_HEADER
} from 'constants/ActionTypes';
// import MailNotification from '../MailNotification/index';
// import AppNotification from '../AppNotification/index';
// import CardHeader from 'components/dashboard/Common/CardHeader/index';
import {switchLanguage, toggleCollapsedNav} from 'actions/Setting';
import IntlMessages from 'util/IntlMessages';
import LanguageSwitcher from 'components/LanguageSwitcher/index';
import Menu from 'components/TopNav/Menu';
import UserInfoPopup from 'components/UserInfo/UserInfoPopup';
import SearchBox from 'components/SearchBox/index';
import { Button } from '@material-ui/core';
import {userSignOut, userSignInSuccess} from 'actions/Auth';
import { searchPersonnelApi, searchUserApi, getUserTokenApi, getUserByUserIdApi } from '../../api/users';
import { getUserRolesFullByUserIdApi } from '../../api/userRoles';
import { history } from '../../store';
import SimpleCrypto from "simple-crypto-js";
import { config } from '../../config';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import ShowUserProfileDialog from '../../app/routes/Users/UserProfileCard/ShowUserProfileDialog';
import ShowUserRolesDialog from '../../app/routes/dialogs/ShowUserRolesDialog';


class Header extends React.Component {

  onAppNotificationSelect = () => {
    this.setState({
      appNotification: !this.state.appNotification
    })
  };
  onMailNotificationSelect = () => {
    this.setState({
      mailNotification: !this.state.mailNotification
    })
  };
  onLangSwitcherSelect = (event) => {
    this.setState({
      langSwitcher: !this.state.langSwitcher, anchorEl: event.currentTarget
    })
  };
  onSearchBoxSelect = () => {
    this.setState({
      searchBox: !this.state.searchBox
    })
  };
  onAppsSelect = () => {
    this.setState({
      apps: !this.state.apps
    })
  };
  onSearchHiddenSelect = () => {
    this.setState({
      isSearchHidden: !this.state.isSearchHidden
    })
  };
  onUserInfoSelect = () => {
    this.setState({
      userInfo: !this.state.userInfo
    })
  };
  handleRequestClose = () => {
    this.setState({
      langSwitcher: false,
      userInfo: false,
      mailNotification: false,
      appNotification: false,
      searchBox: false,
      apps: false,
      isSearchHidden:false
    });
  };
  onToggleCollapsedNav = (e) => {
    const val = !this.props.navCollapsed;
    this.props.toggleCollapsedNav(val);
  };

  constructor() {
    super();
    this.state = {
      anchorEl: undefined,
      searchBox: false,
      searchText: '',
      mailNotification: false,
      userInfo: false,
      langSwitcher: false,
      appNotification: false,
      data : [],
      isSearchHidden:false,
      isOnlyWriter :false,
      personnelSearchText: '',
      personnelSearchResults: [],
      personnelSearchAnchorEl: null,
      personnelSearchLoading: false,
      userSearchText: '',
      userSearchResults: [],
      userSearchAnchorEl: null,
      userSearchLoading: false,
      profileDialogOpen: false,
      profileDialogUser: null,
      rolesDialogOpen: false,
      rolesDialogUser: null
    }
    this.personnelSearchTimeout = null;
    this.userSearchTimeout = null;
  }

  componentDidMount(){
    const userRoles = this.props.authUser.userRoles;
    if(userRoles.filter(x=>x.roleId>1).length > 0 )
    this.setState({  isOnlyWriter:false });
    else
    this.setState({   isOnlyWriter:true });
  }

  updateSearchText = (evt) => {
    const value = evt.target.value;
    this.setState({ personnelSearchText: value });

    // Clear previous timeout
    if (this.personnelSearchTimeout) {
      clearTimeout(this.personnelSearchTimeout);
    }

    // If search text is empty, clear results
    if (!value || value.trim().length < 2) {
      this.setState({
        personnelSearchResults: [],
        personnelSearchAnchorEl: null
      });
      return;
    }

    this.handleUserSearchClose();

    // Debounce search
    this.personnelSearchTimeout = setTimeout(() => {
      this.performPersonnelSearch(value);
    }, 300);
  };

  updateUserSearchText = (evt) => {
    const value = evt.target.value;
    this.setState({ userSearchText: value });

    if (this.userSearchTimeout) {
      clearTimeout(this.userSearchTimeout);
    }

    if (!value || value.trim().length < 2) {
      this.setState({
        userSearchResults: [],
        userSearchAnchorEl: null
      });
      return;
    }

    this.handlePersonnelSearchClose();

    this.userSearchTimeout = setTimeout(() => {
      this.performUserSearch(value);
    }, 300);
  };

  performPersonnelSearch = async (searchTerm) => {
    const isAdmin = this.props.authUser.userRoles.some(x => x.id === 1);
    if (!isAdmin) return;

    this.setState({ personnelSearchLoading: true });

    try {
      const result = await searchPersonnelApi(searchTerm);
      if (result && result.status) {
        this.setState({
          personnelSearchResults: result.data || [],
          personnelSearchAnchorEl: this.personnelSearchInputRef
        });
      }
    } catch (error) {
      console.error('Personnel search error:', error);
      this.setState({ personnelSearchResults: [] });
    } finally {
      this.setState({ personnelSearchLoading: false });
    }
  };

  performUserSearch = async (searchTerm) => {
    const isAdmin = this.props.authUser.userRoles.some(x => x.id === 1);
    if (!isAdmin) return;

    this.setState({ userSearchLoading: true });

    try {
      const result = await searchUserApi(searchTerm);
      if (result && result.status) {
        this.setState({
          userSearchResults: result.data || [],
          userSearchAnchorEl: this.userSearchInputRef
        });
      }
    } catch (error) {
      console.error('User search error:', error);
      this.setState({ userSearchResults: [] });
    } finally {
      this.setState({ userSearchLoading: false });
    }
  };

  handlePersonnelSearchClose = () => {
    this.setState({
      personnelSearchResults: [],
      personnelSearchAnchorEl: null,
      personnelSearchText: ''
    });
  };

  handleUserSearchClose = () => {
    this.setState({
      userSearchResults: [],
      userSearchAnchorEl: null,
      userSearchText: ''
    });
  };

  closeAllAdminSearches = () => {
    this.handlePersonnelSearchClose();
    this.handleUserSearchClose();
  };

  renderAdminSearchDropdown = (results, loading, anchorEl, onClose) => (
    <Popper
      open={results.length > 0 && Boolean(anchorEl)}
      anchorEl={anchorEl}
      placement="bottom-start"
      style={{ zIndex: 1300, width: '600px', marginTop: '8px' }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Paper style={{ maxHeight: '400px', overflow: 'auto' }}>
          {loading ? (
            <div style={{ padding: '16px', textAlign: 'center' }}>Yükleniyor...</div>
          ) : (
            <List dense>
              {results.map((user) => (
                <ListItem key={user.id} divider>
                  <ListItemAvatar>
                    <Avatar
                      src={user.profileImageUrl ? `${config.apiUrl}${user.profileImageUrl}` : `${config.apiUrl}${config.defaultProfileImageUrl}`}
                      alt={`${user.name} ${user.surname}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = `${config.apiUrl}${config.defaultProfileImageUrl}`;
                      }}
                    >
                      {user.name && user.name.charAt(0).toUpperCase()}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={`${user.title || ''} ${user.name} ${user.surname}`.trim()}
                    secondary={
                      <div>
                        <div>{user.email}</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>
                          {user.inst || 'Kurum dışı'} {user.tel ? `• ${user.tel}` : ''}
                        </div>
                      </div>
                    }
                  />
                  <ListItemSecondaryAction>
                    <Button
                      size="small"
                      color="primary"
                      style={{ marginRight: '4px' }}
                      onClick={() => this.handleViewProfile(user.id)}
                    >
                      Profil
                    </Button>
                    <Button
                      size="small"
                      color="default"
                      variant="outlined"
                      style={{ marginRight: '4px' }}
                      onClick={() => this.handleViewRoles(user.id)}
                    >
                      Roller
                    </Button>
                    <Button
                      size="small"
                      color="secondary"
                      variant="contained"
                      onClick={() => this.handleLoginAsUser(user.id)}
                    >
                      Giriş Yap
                    </Button>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          )}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );

  handleViewProfile = async (userId) => {
    try {
      const userData = await getUserByUserIdApi(userId);
      if (userData && userData.status) {
        const user = userData.user || userData.data;
        this.setState({
          profileDialogUser: user,
          profileDialogOpen: true
        });
        this.closeAllAdminSearches();
      }
    } catch (error) {
      console.error('Get user error:', error);
      alert('Kullanıcı bilgileri alınamadı.');
    }
  };

  handleCloseProfileDialog = () => {
    this.setState({
      profileDialogOpen: false,
      profileDialogUser: null
    });
  };

  handleViewRoles = async (userId) => {
    try {
      const userData = await getUserByUserIdApi(userId);
      if (userData && userData.status) {
        const user = userData.user || userData.data;
        this.setState({
          rolesDialogUser: user,
          rolesDialogOpen: true
        });
        this.closeAllAdminSearches();
      }
    } catch (error) {
      console.error('Get user error:', error);
      alert('Kullanıcı bilgileri alınamadı.');
    }
  };

  handleCloseRolesDialog = () => {
    this.setState({
      rolesDialogOpen: false,
      rolesDialogUser: null
    });
  };

  handleLoginAsUser = async (userId) => {
    try {
      // Get user roles
      const rolesData = await getUserRolesFullByUserIdApi(userId);
      if (!rolesData || !rolesData.status) {
        alert('Kullanıcı rolleri alınamadı.');
        return;
      }

      // Get user token
      const tokenResult = await getUserTokenApi(userId);
      if (!tokenResult || !tokenResult.status) {
        alert('Kullanıcı token alınamadı.');
        return;
      }

      // Get full user data
      const userData = await getUserByUserIdApi(userId);
      if (!userData || !userData.status) {
        alert('Kullanıcı bilgileri alınamadı.');
        return;
      }

      const user = userData.user || userData.data;
      user.userRoles = rolesData.userRoles.map(role => ({
        id: role.roleId,
        name: role.name,
        appId: 0,
        inst: role.inst,
        customId: role.customId
      }));

      // Save to localStorage and update Redux
      const simpleCrypto = new SimpleCrypto(config.sk);
      localStorage.setItem("user", simpleCrypto.encryptObject(user));
      localStorage.setItem("userToken", tokenResult.token);

      this.props.userSignInSuccess(user);
      this.closeAllAdminSearches();
      history.push("/bbs/mainPage");
    } catch (error) {
      console.error('Login as user error:', error);
      alert('Giriş yapılırken bir hata oluştu.');
    }
  };
 


  Apps = () => {
    return (
      <ul className="jr-list jr-list-half">
        <li className="jr-list-item">
            <Link className="jr-list-link" to="/bbs/calendar/basic">
                <i className="zmdi zmdi-calendar zmdi-hc-fw"/>
                <span className="jr-list-text"><IntlMessages id="sidebar.calendar.basic"/></span>
            </Link>
        </li>

        <li className="jr-list-item">
          <Link className="jr-list-link" to="/bbs/to-do">
            <i className="zmdi zmdi-check-square zmdi-hc-fw"/>
            <span className="jr-list-text"><IntlMessages id="sidebar.appModule.toDo"/></span>
          </Link>
        </li>

        <li className="jr-list-item">
          <Link className="jr-list-link" to="/bbs/mail">
            <i className="zmdi zmdi-email zmdi-hc-fw"/>
            <span className="jr-list-text"><IntlMessages id="sidebar.appModule.mail"/></span>
          </Link>
        </li>

        <li className="jr-list-item">
            <Link className="jr-list-link" to="/bbs/chat">
                <i className="zmdi zmdi-comment zmdi-hc-fw"/>
                <span className="jr-list-text"><IntlMessages id="sidebar.appModule.chat"/></span>
            </Link>
        </li>

        <li className="jr-list-item">
            <Link className="jr-list-link" to="/bbs/contact">
                <i className="zmdi zmdi-account-box zmdi-hc-fw"/>
                <span className="jr-list-text"><IntlMessages id="sidebar.appModule.contact"/></span>
            </Link>
        </li>

        <li className="jr-list-item">
            <Link className="jr-list-link" to="/">
                <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw"/>
                <span className="jr-list-text">Add New</span>
            </Link>
        </li>
      </ul>)
  };

  render() {
    const {drawerType, locale, navigationStyle, horizontalNavPosition} = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'd-block d-xl-none' : drawerType.includes(COLLAPSED_DRAWER) ? 'd-block' : 'd-none';

    const isAbsisAuth  = this.props.authUser.userRoles.some(x=>x.id===7 || x.id===1);
    const isAdmin = this.props.authUser.userRoles.some(x => x.id === 1);

    return (
      <AppBar
        className={`app-main-header ${(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) ? 'app-main-header-top' : ''}`}>
        <Toolbar className="app-toolbar" disableGutters={false}>
          {navigationStyle === HORIZONTAL_NAVIGATION ?
            <div className="d-block d-md-none pointer mr-3" onClick={this.onToggleCollapsedNav}>
                            <span className="jr-menu-icon">
                              <span className="menu-icon"/>
                            </span>
            </div>
            :
            <IconButton className={`jr-menu-icon mr-3 ${drawerStyle}`} aria-label="Menu"
                        onClick={this.onToggleCollapsedNav}>
              <span className="menu-icon"/>
            </IconButton>
          }

          <Link className="app-logo mr-2 d-none d-sm-block" to="/">
          {
                this.props.locale.locale ==="en" ? 
                <img src={require("assets/images/bbs_logo/bbs3_en.png")} alt="IIS" title="IIS"/> 
                :
                <img src={require("assets/images/bbs_logo/bbs3.png")} alt="BBS" title="BBS"/>
            }
           
          </Link>
      
          {/* <img src={require("assets/images/100.png").default} style={{  width:'100px'}} /> */}
 
          {isAdmin && (
            <div style={{ position: 'relative', marginRight: '16px', display: 'flex', gap: '12px' }}>
              <div style={{ position: 'relative' }}>
                <div ref={(el) => { this.personnelSearchInputRef = el; }}>
                  <SearchBox
                    styleName="d-none d-lg-block"
                    placeholder="Personel ara..."
                    onChange={this.updateSearchText}
                    value={this.state.personnelSearchText}
                    onKeyDown={(e) => {
                      if (e.key === 'Escape') {
                        this.handlePersonnelSearchClose();
                      }
                    }}
                  />
                </div>
                {this.renderAdminSearchDropdown(
                  this.state.personnelSearchResults,
                  this.state.personnelSearchLoading,
                  this.state.personnelSearchAnchorEl,
                  this.handlePersonnelSearchClose
                )}
              </div>

              <div style={{ position: 'relative' }}>
                <div ref={(el) => { this.userSearchInputRef = el; }}>
                  <SearchBox
                    styleName="d-none d-lg-block"
                    placeholder="Kullanıcı ara..."
                    onChange={this.updateUserSearchText}
                    value={this.state.userSearchText}
                    onKeyDown={(e) => {
                      if (e.key === 'Escape') {
                        this.handleUserSearchClose();
                      }
                    }}
                  />
                </div>
                {this.renderAdminSearchDropdown(
                  this.state.userSearchResults,
                  this.state.userSearchLoading,
                  this.state.userSearchAnchorEl,
                  this.handleUserSearchClose
                )}
              </div>
            </div>
          )}
                     
         {/* burayı açılır menü için yapıyoruz aramalarda sonuç ekraı için */}

      
      

          {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === INSIDE_THE_HEADER) &&
          <Menu/>}

          <ul className="header-notifications list-inline ml-auto">


            {/* <li className="list-inline-item"> 
              <Dropdown
                className="quick-menu app-notification"
                isOpen={this.state.apps}
                toggle={this.onAppsSelect.bind(this)}>

                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown">
                  <span className="app-notification-menu">
                    <i className="zmdi zmdi-apps zmdi-hc-fw zmdi-hc-lg"/>
                    <span>Uygulamalar</span>
                  </span>
                </DropdownToggle>

                <DropdownMenu>
                  {this.Apps()}
                </DropdownMenu>
              </Dropdown>
            </li> */}
            <li className="d-inline-block d-lg-none list-inline-item">
              <Dropdown
                className="quick-menu nav-searchbox"
                isOpen={this.state.searchBox}
                toggle={this.onSearchBoxSelect.bind(this)}>

                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown">
                  <IconButton className="icon-btn">
                    <i className="zmdi zmdi-search zmdi-hc-fw"/>
                  </IconButton>
                </DropdownToggle>

           
              </Dropdown> 
            </li>

         
            <li className="list-inline-item">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.langSwitcher}
                toggle={this.onLangSwitcherSelect.bind(this)}>

                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown">
                  <IconButton className="icon-btn">
                    <i className={`flag flag-24 flag-${locale.icon}`}  style={{ backgroundImage: `url(${require("assets/images/flag.png").default})` }} />
                  </IconButton>
                </DropdownToggle>

                <DropdownMenu right className="w-50">
                  <LanguageSwitcher switchLanguage={this.props.switchLanguage}
                                    handleRequestClose={this.handleRequestClose}/>
                </DropdownMenu>
              </Dropdown>


            </li>
            {
              isAbsisAuth && <Button variant="outlined" color="inherit" style={{marginRight: '10px', color: 'white'}} href={`/bbs/absis/userDetail/${this.props.authUser.id}`}>
                <i className="zmdi zmdi-account zmdi-hc-fw mr-2"/>
             
                      <IntlMessages id="sidebar.absis.my" />{" "}
               
              </Button>
            }

            <Button variant="outlined" color="inherit" style={{marginRight: '10px', color: 'white'}} href='/bbs/profile'>
            <i className="zmdi zmdi-account zmdi-hc-fw mr-2"/>
            <IntlMessages id="popup.profile"/>
          </Button>
       
          <Button variant="contained" color="secondary" style={{marginRight: '10px'}} onClick={() => {
            this.handleRequestClose();
            this.props.userSignOut()
          }}>
            <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2"/>

            <IntlMessages id="popup.logout"/>
          </Button>


                  {/*
            <li className="list-inline-item app-tour">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.appNotification}
                toggle={this.onAppNotificationSelect.bind(this)}>

                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown">
                  <IconButton className="icon-btn">
                    <i className="zmdi zmdi-notifications-none icon-alert animated infinite wobble"/>
                  </IconButton>
                </DropdownToggle>

                <DropdownMenu right>
                  <CardHeader styleName="align-items-center"
                              heading="Bildirimler"/>
                  <AppNotification/>
                </DropdownMenu>
              </Dropdown>
            </li>
          <li className="list-inline-item mail-tour">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.mailNotification}
                toggle={this.onMailNotificationSelect.bind(this)}
              >
                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown">

                  <IconButton className="icon-btn">
                    <i className="zmdi zmdi-comment-alt-text zmdi-hc-fw"/>
                  </IconButton>
                </DropdownToggle>


                <DropdownMenu right>
                  <CardHeader styleName="align-items-center"
                              heading={<IntlMessages id="mailNotification.title"/>}/>
                  <MailNotification/>
                </DropdownMenu>
              </Dropdown>
            </li> */}

{/* yatay menü devre dışı oldudğu için bu kısma dokulumaladı */}
            {navigationStyle === HORIZONTAL_NAVIGATION &&
            <li className="list-inline-item user-nav">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.userInfo}
                toggle={this.onUserInfoSelect.bind(this)}>

                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown">
                  <IconButton className="icon-btn size-30">
                    <Avatar
                      alt='...'
                      src={'https://via.placeholder.com/150x150'}
                      className="size-30"
                    />
                  </IconButton>
                </DropdownToggle>

                <DropdownMenu right>
                  <UserInfoPopup/>
                </DropdownMenu>
              </Dropdown>
            </li>}
          </ul>
          
          <div className="ellipse-shape"></div>
        </Toolbar>

        {/* Profil Dialog */}
        {this.state.profileDialogUser && (
          <ShowUserProfileDialog
            user={this.state.profileDialogUser}
            open={this.state.profileDialogOpen}
            onModalClose={this.handleCloseProfileDialog}
          />
        )}

        {/* Roller Dialog */}
        {this.state.rolesDialogUser && (
          <ShowUserRolesDialog
            user={this.state.rolesDialogUser}
            open={this.state.rolesDialogOpen}
            onModalClose={this.handleCloseRolesDialog}
          />
        )}
      </AppBar>
    );
  }

}


const mapStateToProps = ({settings,auth}) => {
  const {drawerType, locale, navigationStyle, horizontalNavPosition} = settings;
  const {authUser} = auth;
  return {drawerType, locale, navigationStyle, horizontalNavPosition,authUser}
};

export default withRouter(connect(mapStateToProps, {toggleCollapsedNav, switchLanguage, userSignOut, userSignInSuccess})(Header));